// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"4e1ccce5","943":"b4477538"}[chunkId] + ".chunk.js";
};